let init = function() {
  function showAllTags() {
    document.querySelectorAll('.is-hidden-tag').forEach((tagElement) => {
      tagElement.classList.remove("is-hidden-tag", "is-hidden");
    });
    this.remove()
  }
  document.getElementById("showAllTagsButton").addEventListener('click', showAllTags);
};
window.addEventListener("load", init, false);
